"use strict";

/**
 *  Konfigurator Keilfenster ( snippets/product-keilfenster-confi.liquid ) ,
 *  API : wedge-window-* . Ablauf , Preis und Warenkorb : confi-wall.js
 */
(function (root) {
  var Wall = typeof module !== 'undefined' && module.exports ? require('./confi-wall.js') : root.ConfiWall;
  var definition = {
    confi: 'keilfenster-confi',
    endpoint: 'wedge-window',
    wallType: 'wedgeWindow',
    required: function required() {
      return ['width', 'heightHigh', 'heightLow'];
    },
    body: function body(values) {
      return {
        width: Wall.number(values.width),
        heightHigh: Wall.number(values.heightHigh),
        heightLow: Wall.number(values.heightLow),
        glassColor: values.glassColor,
        frameColor: values.frameColor,
        position: values.position
      };
    },
    fromInfo: function fromInfo(data) {
      return {
        width: data.width,
        heightHigh: data.heightHigh,
        heightLow: data.heightLow,
        glassColor: data.glassColor,
        frameColor: data.frameColor,
        position: data.position
      };
    }
  };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = definition;
  }
  if (root && root.document) {
    root.document.addEventListener('DOMContentLoaded', function () {
      return Wall.start(definition);
    });
  }
})(typeof window !== 'undefined' ? window : null);